import { toSentenceCase } from "../../../CommonMethhods/CommonMethods";

// Reason Type shown to the checker: the maker's chosen category, with anything
// that is not New / Update mapping treated as "Others".
export const getReasonTypeLabel = (data) => {
  const reasonType = data?.reasonType;
  if (reasonType) {
    switch (reasonType.toLowerCase()) {
      case "newmapping":
        return "New Mapping";
      case "updatemapping":
        return "Update existing mapping";
      case "others":
        return "Others";
      default:
        return toSentenceCase(reasonType);
    }
  }

  const reason = data?.reason || "";
  if (reason.toLowerCase() === "new mapping") return "New Mapping";
  if (reason.toLowerCase() === "update existing mapping") return "Update existing mapping";
  if (reason) return "Others";
  return "-";
};

export const normalizeStatus = (status = "") =>
  (status || "").toLowerCase().replace(/[\s_-]/g, "");
